import { createContext, useContext } from "react";

type CopyableMode = "visible" | "reveal";
const CopyableContext = createContext<CopyableMode>("reveal");
export const CopyableProvider = CopyableContext.Provider;
export const useCopyableMode = () => useContext(CopyableContext);
